<template>
  <v-card class='card' elevation-1 v-if="!isDeleted">
    <v-menu class='cardMenu' bottom left v-if="showMenu()">
      <v-btn slot="activator" icon>
        <v-icon color="primary">more_vert</v-icon>
      </v-btn>
      <v-list>
        <div v-if="showMenu()">
           <v-list-tile @click="sticky()" v-if="card.sticky != true && this.canSticky()">
            <v-list-tile-title>Make Sticky</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="unsticky()" v-if="card.sticky == true && this.canSticky()">
            <v-list-tile-title>Unsticky</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="canEdit()" :to="{ path: '/group/edit-'+card.card_type.type+'-card/'+card.pivot.group_id+'/'+card.id }">
            <v-list-tile-title>Edit Card</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="canDelete()" @click="deleteCard()">
            <v-list-tile-title>Delete Card</v-list-tile-title>
          </v-list-tile>
        </div>
      </v-list>
    </v-menu>
    <v-responsive>
      <v-container fluid class='pa-0'>
        <v-layout class='mb-2' wrap row>
          <v-flex class='mr-2 text-xs-center cardType' md1 xs2 v-bind:style="{ backgroundColor: tagColor }">
            <v-icon color="white" size="30" class=''>{{card.card_type.icon}}</v-icon>
          </v-flex>
          <v-flex class='pt-3 pl-2' md10 xs8>
            <AmazeAvatar v-if="card.user" :user="card.user" :key="card.user.id" size="28px" hideTip="true" class="pa-0 mr-2"></AmazeAvatar>
            <router-link :to="{ path: '/profile/'+card.user.id }">
              <span class='username groupUsername'>{{card.user.display_name}}</span>
            </router-link>
            <div class="inlineInfo">
              <span class="groupTimestamp timestamp time cardTime mr-2">· {{ card.created_at | localTime }} ago</span>
              <span class="isSticky" v-if="this.card.sticky"><i class="fas fa-thumbtack"></i></span>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class='cardContent amazeEditorHtml'>
          <component class='cardComponent px-4 py-2' :is='card.card_type.type' :data='card'></component>
        </v-layout>
      </v-container>
    </v-responsive>

    <v-card-actions class='px-3'>
      <AmazeComment :card-id="card.id" :group="group" :group-id="card.pivot.group_id" :inputComments="card.card_comments">
        <AmazeLike :card-id="card.id" :group-id="card.pivot.group_id" :inputLikers="card.card_likes"></AmazeLike>
        <AmazeCardLink :card-id="card.id" :group-id="card.pivot.group_id"></AmazeCardLink>
      </AmazeComment>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" scoped>
  @import "src/styles/variables.scss";
  .card {
    width: 100%;
    position: relative;
    .cardMenu {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 2;
    }
  }
  .cardContent {
    width: 100%;
    word-break: break-word;
  }
  .cardComponent {
    width: 100%;
  }
  .cardType {
    color: #ffffff;
    background-color: $amaze-teal;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      margin-top: 4px;
    }
  }
  .username {
    font-size: 13px;
    color: $font-color;
    font-weight: bold;
  }
  .inlineInfo {
    display: inline-block;
    white-space: nowrap;
    i {
      font-size: 11px;
    }
  }
  @media (max-width: 791px) {
    .inlineInfo {
      display: block;
    }
  }

  ::v-deep.card .v-responsive__content {
    max-width: 100%;
    .cardContent * {
      max-width: 100%;
      height: auto;
    }
  }
</style>

<script>
import AmazeLike from "@/components/Widgets/AmazeLike";
import AmazeCardLink from "@/components/Widgets/AmazeCardLink";
import AmazeComment from "@/components/Widgets/AmazeComment";
import AmazeAvatar from "@/components/Widgets/AmazeAvatar";

import discussion from "@/components/Widgets/CardTypes/discussion";
import resource from "@/components/Widgets/CardTypes/resource";
import observation from "@/components/Widgets/CardTypes/observation";
import { EventBus } from "@/components/Events/event-bus.js";

export default {
  components: {
    AmazeLike,
    AmazeCardLink,
    AmazeComment,
    AmazeAvatar,
    discussion,
    resource,
    observation,
    EventBus
  },
  computed: {
    tagColor() {
      return this.card.card_type.color;
    }
  },
  props: ["card", "group", "single"],
  data() {
    return {
      isDeleted: false
    };
  },
  mounted() {

  },
  methods: {
    cardIsMine() {
      // Is this card mine?
      return this.$auth.user().id === this.card.user_id;
    },
    sticky() {
      this.makeSticky(true);
    },
    unsticky() {
      this.makeSticky(false);
    },
    userIsAdmin() {
      return this.$auth.check('uber_admin') ||
        (this.group.hasOwnProperty('owner') && this.group.owner === true) ||
        (this.group.hasOwnProperty('my_role') && this.group.my_role === 'admin');
    },
    canSticky() {
      // Uber admin can sticky.
      // Group creator/owner & group admins can sticky their own cards,
      // but not the cards of others since sticky == editing and
      // you don't have permissions to edit others' cards unless
      // you're an uber admin.
      return this.userIsAdmin() ||
        (this.cardIsMine() && ((this.group.hasOwnProperty('owner') && this.group.owner === true) ||
        (this.group.hasOwnProperty('my_role') && this.group.my_role === 'admin')));
    },
    canDelete() {
      return this.cardIsMine() || this.userIsAdmin();
    },
    canEdit() {
      return this.cardIsMine() || this.userIsAdmin();
    },
    showMenu() {
      return this.canSticky() || this.canEdit() || this.canDelete() || this.userIsAdmin();
    },
    makeSticky(sticky) {
      // Let's do some more auth checking here por favor.
      if (this.canSticky()) {
        const crd = this.card;
        crd.sticky = sticky;
        const groupId = this.$route.params.id;

        this.$http.put("cards/" + this.card.id, crd).then(
          response => {
            this.card.sticky = response.data.sticky;
            EventBus.$emit("refresh-cards", groupId, true, true);
          },
          response => {
            console.log("Unable to sticky.");
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message:
              "You don't have permission to make this card sticky.",
          snackbar: true
        });
      }
    },
    deleteCard() {
      this.$http.delete("cards/" + this.card.id).then(
        response => {
          this.isDeleted = true;
          EventBus.$emit("card-deleted", this.card, this.group);
        },
        response => {
          console.log("Error deleting file.");
        }
      );
    }
  }
};
</script>
